
import { defineComponent } from "vue";
import PreciselySearch from "@/components/search/PreciselySearch.vue";

import Data8Search from "@/components/search/Data8Search.vue";
import AutoaddressSearch from "@/components/search/AutoaddressSearch.vue";
import AddressProviderSwitch from "@/components/search/AddressProviderSwitch.vue";
import { AnyProvider, ProviderType } from "@/types";
import Empty from "@/components/shared/Empty.vue";
import { useOrgSettings } from "@/services";
import { mapState } from "pinia";

export default defineComponent({
  name: "AddressSearch",
  components: {
    AddressProviderSwitch,
  },
  computed: {
    ...mapState(useOrgSettings, ["searchProviderIndex"]),
    searchProviders(): AnyProvider[] {
      return useOrgSettings().searchProviders.map((p) => ({
        ...p,
        component: this.getSearchComponent(p.providerType),
      }));
    },
    searchCountry: {
      get(): string {
        return this.searchProviders[this.searchProviderIndex]?.country || "";
      },
      set(val: string): void {
        const index = this.searchProviders.findIndex((f) => f.country === val);
        if (index > -1) {
          useOrgSettings().searchProviderIndex = index;
        }
      },
    },
  },

  methods: {
    getSearchComponent(providerType: ProviderType) {
      switch (providerType) {
        case ProviderType.AutoAddress:
          return AutoaddressSearch;
        case ProviderType.PitneyBowes:
          return PreciselySearch;
        case ProviderType.Data8:
          return Data8Search;

        default:
          return Empty;
      }
    },
  },
});
